import * as stringUtils from "StringUtils";
import visibilityEvaluator from "VisibilityEvaluator";
import ko, { type Computed } from "knockout";
import { onUnmounted, ref, watch, type Ref } from "vue";
import type { MaybeRefOrGetter } from "vue3-polyfill";
import { useBindingContext } from "./BindingContextHook";
import { useUltimateDataItem } from "./UltimateDataItemHook";

export function useConditionalVisibility(
  bindingPath: MaybeRefOrGetter<string>,
  conditionExpressionOrPK: string,
): Ref<boolean> {
  const isVisible = ref(false);
  const bindingContext = useBindingContext();
  const boundDataItem = useUltimateDataItem(bindingPath);

  if (bindingContext) {
    let computed: Computed;
    watch(
      () => [bindingContext.value, boundDataItem.value],
      ([rootDataItem, dataItem]) => {
        computed && computed.dispose();
        computed = ko.computed(() => {
          isVisible.value = stringUtils.isGuid(conditionExpressionOrPK)
            ? visibilityEvaluator.isVisibleFromConditionWithFallback(rootDataItem, dataItem, conditionExpressionOrPK)
            : visibilityEvaluator.isVisibleFromExpression(rootDataItem, conditionExpressionOrPK);
        });
      },
      {
        immediate: true,
      },
    );

    onUnmounted(() => computed.dispose());
  }

  return isVisible;
}
